export default __webpack_public_path__ + "assets/8783c5746e80100958afe251c6ad9e0a.svg";